/* Moved from sections/hlth-benefits-timeline.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var timeline = document.getElementById('hlth-bt-timeline-' + SID + '');
        if (!timeline) return;
        var progress = document.getElementById('hlth-bt-progress-' + SID + '');
        var items = timeline.querySelectorAll('[data-bt-item]');
        if (!items.length) return;

        /* Compute line bounds so the grey/progress line runs from first dot center to last dot center */
        function lineBounds() {
          var firstItem = items[0];
          var lastItem = items[items.length - 1];
          /* Dot: 30px mobile (halfDot 15, top 2), 34px tablet+ (halfDot 17, top 4) */
          var isTablet = window.innerWidth >= 750;
          var halfDot = isTablet ? 17 : 15;
          var dotTopOffset = isTablet ? 4 : 2;
          var top = firstItem.offsetTop + dotTopOffset + halfDot;
          var bottom = lastItem.offsetTop + dotTopOffset + halfDot;
          return { top: top, height: Math.max(0, bottom - top) };
        }

        function positionLine() {
          var b = lineBounds();
          timeline.style.setProperty('--bt-line-top', b.top + 'px');
          timeline.style.setProperty('--bt-line-height', b.height + 'px');
        }

        positionLine();
        window.addEventListener('resize', positionLine);

        /* Reduced motion: show everything, skip animation */
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          items.forEach(function(item) {
            item.classList.add('is-active');
          });
          progress.style.height = lineBounds().height + 'px';
          return;
        }

        function initTimeline() {
          if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            /* Fallback: just show everything if GSAP unavailable */
            items.forEach(function(item) {
              item.classList.add('is-active');
            });
            progress.style.height = lineBounds().height + 'px';
            return;
          }

          gsap.registerPlugin(ScrollTrigger);

          var lastItem = items[items.length - 1];

          /* Progress bar — scrubbed to scroll, grows as you scroll through the timeline */
          ScrollTrigger.create({
            trigger: timeline,
            start: 'top 60%',
            end: function() { return '+=' + (lastItem.offsetTop + lastItem.offsetHeight); },
            scrub: 1.2,
            onUpdate: function(self) {
              var maxH = lineBounds().height;
              gsap.set(progress, { height: Math.round(maxH * self.progress) });
            }
          });

          /* Each item — reveals as scroll reaches it, with cascading flow.
             Trigger well on-screen (60%) so the user sees the full animation.
             Each item animates over 0.8s with power2.out for smooth deceleration.
             The staggered triggers + progress bar create a connected flowing feel. */
          items.forEach(function(item) {
            ScrollTrigger.create({
              trigger: item,
              start: 'top 65%',
              once: true,
              onEnter: function() {
                item.classList.add('is-active');
              }
            });
          });
        }

        /* Wait for DOMContentLoaded or run immediately if already loaded */
        if (document.readyState === 'loading') {
          (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initTimeline) : initTimeline());
        } else {
          initTimeline();
        }

        document.addEventListener('shopify:section:load', function() {
          positionLine();
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        });

        var videoWrap = document.querySelector('.hlth-bt-' + SID + ' [data-bt-video]');
        if (videoWrap) {
          var video = videoWrap.querySelector('video');
          var overlay = videoWrap.querySelector('[data-bt-play-overlay]');
          var thumb = videoWrap.querySelector('.hlth-bt-media__thumb');
          var playBtn = videoWrap.querySelector('[data-bt-playpause]');
          var muteBtn = videoWrap.querySelector('[data-bt-mute]');
          var iconPlay = playBtn ? playBtn.querySelector('[data-icon-play]') : null;
          var iconPause = playBtn ? playBtn.querySelector('[data-icon-pause]') : null;
          var iconUnmute = muteBtn ? muteBtn.querySelector('[data-icon-unmute]') : null;
          var iconMute = muteBtn ? muteBtn.querySelector('[data-icon-mute]') : null;

          function updatePlayIcons() {
            if (!iconPlay) return;
            iconPlay.style.display = video.paused ? '' : 'none';
            iconPause.style.display = video.paused ? 'none' : '';
          }

          if (overlay) {
            overlay.addEventListener('click', function() {
              video.play();
              overlay.classList.add('is-hidden');
              if (thumb) thumb.classList.add('is-hidden');
              updatePlayIcons();
            });
          }

          if (playBtn) {
            playBtn.addEventListener('click', function() {
              if (video.paused) {
                video.play();
                if (overlay) overlay.classList.add('is-hidden');
                if (thumb) thumb.classList.add('is-hidden');
              } else {
                video.pause();
              }
              updatePlayIcons();
            });
          }

          if (muteBtn) {
            muteBtn.addEventListener('click', function() {
              video.muted = !video.muted;
              iconUnmute.style.display = video.muted ? 'none' : '';
              iconMute.style.display = video.muted ? '' : 'none';
            });
          }
        }

        var bioToggle = document.querySelector('.hlth-bt-' + SID + ' [data-bt-bio-toggle]');
        var modal = document.querySelector('.hlth-bt-' + SID + ' [data-bt-modal]');
        if (bioToggle && modal) {
          var modalClose = modal.querySelector('[data-bt-modal-close]');
          bioToggle.addEventListener('click', function() {
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          });
          modalClose.addEventListener('click', function() {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          });
          modal.addEventListener('click', function(e) {
            if (e.target === modal) {
              modal.classList.remove('is-open');
              document.body.style.overflow = '';
            }
          });
        }

      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-benefits-timeline')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-benefits-timeline').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_benefits_timeline) return;
      w.__hlthJs_hlth_benefits_timeline = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
